
import WinBase from "./winBase";
import {AssertUtils,GoingUtils} from "goingutils";
import GoingForm from "../../../jsCom/comCtl/goingForm";
import EditorTypeUtils from "../../../common/editorTypeUtils";

class ShowFormWin extends WinBase {

    constructor(options) {
        super(options);
        this.options = $.extend({}, options);
        this.initFun = options["initFun"];
        let defConfig = {
            colNum: 1,
            labelWidth: 90,
            inputWidth: 200
        };
        options.config = $.extend(defConfig, options.config);
    }

    /**
     * 激活form窗口对象
     * @param vueObj
     * @returns {*}
     */
    showWin(options, vueObj) {
        let flat = true;
        if (AssertUtils.isFunction(this.options["showBefore"])) {
            flat = this.options["showBefore"](vueObj);
            if (!flat) {
                return void 0;
            }
        }
        let divId = GoingUtils.getUUid(12);
        let goingForm = new GoingForm("editor", null, false);
        //初始化form对象
        goingForm.initForm({
            fieldAry: options.config.fieldAry,
            colNum: options.config.colNum,
            labelWidth: options.config.labelWidth,
            inputWidth: options.config.inputWidth
        });
        let formHtml = goingForm.html();
        let htmlContent = `<div id='${divId}' class="going-win-form">${formHtml}</div>`;
        //弹出窗口
        this.showDialogWin(htmlContent,this.options["closeWin"]);
        //初始化控件 根据类名称
        EditorTypeUtils.initGoCtlByClass(
            $(`#${divId}`),
            goingForm.inputWidth,
            goingForm
        );
        //初始化容器的高度
        this.initWinContainer(divId);
        //初始化底部操作栏
        this.addBottomBar(divId);
        //初始化底部事件
        this.initBottomEvent({divId, goAclWin:goingForm, vueObj,closeWin:this.options["closeWin"]});
        //如果存在初始化函数
        if (
            AssertUtils.isNotEmpty(this.initFun) &&
            AssertUtils.isFunction(this.initFun)
        ) {
            this.initFun(goingForm);
        }
        return divId;
    }
}

export default ShowFormWin;



// WEBPACK FOOTER //
// ./goingsrc/jsCom/go-dialog/components/showFormWin.js